import styled from "@emotion/styled";
import { Row, Col } from "antd";
import touzi4 from "../../../../../images/touzi-4.png";
import jianshebox from "../../../../../images/jianshe-box.png";
import jiansheActive from "../../../../../images/jianshe-item.png";
import classNames from "classnames";
import { useState, useEffect } from "react";
import { menuMap } from "./config";
import FileLinks from "./FileLinks";
const Layout = styled.div`
  background-color: rgba(1, 104, 126, 0.9);
  border: 2px solid #00c9d0;
  box-shadow: 0 0 12px #00383f;
  border-radius: 8px;
  padding: 20px 25px;
  .ant-empty-description {
    color: white;
  }
  .navs {
    display: flex;
    justify-content: start;
    font-size: 22px;
    color: #fff;
    font-weight: bold;
    margin-top: 46px;
    transition: all 0.2s;
    .nav {
      cursor: pointer;
      padding-right: 20px;
      &:hover,
      &.active {
        color: #fcee21;
      }
    }
  }
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #feffff;
    margin-bottom: 20px;
  }
  .touzi {
    margin-top: 43px;
    &-title {
      align-items: center;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      img {
        margin-right: 19px;
      }
    }
    .touzi-info {
      margin-top: 27px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      .value {
        font-weight: 400;
      }
    }
  }
  .jianshe {
    /* margin-top: 48px; */
    &-title {
      align-items: center;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      img {
        margin-right: 19px;
      }
    }
    .ant-col {
      margin-bottom: 30px;
    }
    &-info {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      margin-top: 25px;
      .jianshe-box {
        width: 341px;
        height: 41px;
        background-image: url(${jianshebox});
        align-items: center;
        .status-item {
          flex: 1;
          height: 30px;
          text-align: center;
          line-height: 30px;
        }
        .active {
          background-image: url(${jiansheActive});
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
      .label {
        margin-right: 95px;
      }
      .value {
        font-weight: 400;
      }
    }
  }
`;
const getValue = (item: any) => {
  if (typeof item.value === "function") return item.value();
  return item;
};
const getItem = (item: any, subIndex: number) => {
  const getValueItem = () => {
    switch (item.componentType) {
      case "file": {
        return (
          <div style={{ marginTop: 10 }}> {FileLinks(getValue(item), "")} </div>
        );
      }
      case "custom": {
        return getValue(item);
      }
      default: {
        return <div className="value">{getValue(item)}</div>;
      }
    }
  };
  const baseComponent = () => {
    const className = ["file", "custom"].includes(item.componentType)
      ? ""
      : "flex ac";

    return (
      <Col span={item.span} key={subIndex}>
        <div className={className}>
          {item.label && (
            <div
              className="label"
              style={item.labelStyle}
              //   style={{ marginRight: "8px" }}
            >
              {item.label}:{" "}
            </div>
          )}
          {getValueItem()}
        </div>
      </Col>
    );
  };

  if (item.visiable) {
    if (!item.visiable()) return null;
    return baseComponent();
  } else {
    return baseComponent();
  }
};
export const CommonDetail: React.FC<{
  details: any[];
  type: string;
  record: any;
}> = ({ details, type, record }) => {
  const [setting, setSetting] = useState(menuMap[type]);
  const tabs = setting?.tabs?.(record, type);
  const [activeIndex, setActiveIndex] = useState(tabs?.[0]?.key || "");
  const [currentTab, setCurrentTab] = useState(tabs?.[0]);
  const className = "";
  return (
    <>
      {" "}
      <Layout>
        {details.map((data: Record<string, any>) => {
          return (
            <div className={className} key={data.title()}>
              <div className="title">{data.title()}</div>
              {data.panels.map((panel: any) => {
                return (
                  <div className="jianshe">
                    <div className="flex jianshe-title ac">
                      <img src={touzi4} width="30px" height="30px" alt="" />
                      <span>{panel.title()}</span>
                    </div>
                    <Row className="jianshe-info">
                      {panel.items.map((item: any, subIndex: number) => {
                        {
                          return getItem(item, subIndex);
                        }
                      })}
                    </Row>
                  </div>
                );
              })}
            </div>
          );
        })}
        {setting.tabs && (
          <div className="navs">
            {tabs.map((tab: any, index: number) => {
              return (
                <div
                  key={tab.key}
                  className={classNames("nav", {
                    active: tab.key == activeIndex,
                  })}
                  onClick={() => {
                    setActiveIndex(tab.key);
                    setCurrentTab(
                      tabs.find((item: any) => {
                        return item.key == tab.key;
                      })
                    );
                  }}
                >
                  {tab.label}
                </div>
              );
            })}
          </div>
        )}
      </Layout>
      {setting.tabs && tabs.length && (
        <Layout style={{ marginTop: "8px" }}>
          {currentTab && (
            <div className={className} key={currentTab.label}>
              {/* <div className="title">{currentTab.title()}</div> */}
              {currentTab.panels(record).map((panel: any) => {
                if (panel.visiable && !panel.visiable()) {
                  return null;
                }
                return (
                  <div className="jianshe">
                    {panel.title && panel.title() && (
                      <div className="flex jianshe-title ac">
                        <img src={touzi4} width="30px" height="30px" alt="" />
                        <span>{panel.title()}</span>
                      </div>
                    )}

                    <Row className="jianshe-info">
                      {panel.items.map((item: any, subIndex: number) => {
                        {
                          return getItem(item, subIndex);
                        }
                      })}
                    </Row>
                  </div>
                );
              })}
            </div>
          )}
        </Layout>
      )}
    </>
  );
};
